import { Component, EventEmitter, Input, Output, TemplateRef } from '@angular/core';
import { CalendarEvent, CalendarEventAction } from 'angular-calendar';

@Component({
    selector: 'sgt-calendar-list',
    templateUrl: './calendar-list.component.html',
    styleUrls: ['./calendar-list.component.less']
})
export class CalendarListComponent {
    @Input() viewDate: Date;
    @Input() locale = 'pt-BR';
    @Input() events: CalendarEvent[];
    @Input() eventTemplate: TemplateRef<any>;

    @Output() eventClicked = new EventEmitter<CalendarEvent>();

    /** Ao clicar no dropdown das ações */
    dropdownEventActionsClick(dropdownEventActions: HTMLDivElement, mouseEvent: MouseEvent) {
        // Abrindo/Fechando o Dropdown
        (jQuery(dropdownEventActions).find('.dropdown-toggle') as any).dropdown('toggle');
        // Paramos o evento do click para não abrir a atividade
        mouseEvent.stopPropagation();
    }

    /** Ao criar em alguma ação */
    actionClick(event: CalendarEvent, action: CalendarEventAction, mouseEvent: MouseEvent, dropdownEventActions: HTMLDivElement) {
        action.onClick({event, sourceEvent: mouseEvent});

        (jQuery(dropdownEventActions).find('.dropdown-toggle') as any).dropdown('hide');

        // Paramos o evento do click para não abrir a atividade
        mouseEvent.stopPropagation();
    }
}
